<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
      <div class="d-flex">
        <b-button
          class="my-1 mr-50"
          variant="outline-primary"
          :to="{ name: 'add-exercise' }"
        >
          ایجاد تمرین
        </b-button>
        <b-button
          class="my-1"
          variant="outline-danger"
          @click="removeExercises"
        >
          حذف تمرین ها
        </b-button>
      </div>
    </div>

    <data-table :fields="fields" :items="exercises" :loading="loading">
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeExercisesData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        {{ data.item.id }}
      </template>

      <template #title="{ data }"
        ><div style="white-space: nowrap">{{ data.item.title }}</div></template
      >
      <template #detail="{ data }">
        <b-button
          size="sm"
          variant="flat-secondary"
          @click="data.toggleDetails"
        >
          <span class="ml-50">مشاهده جزییات</span>
        </b-button></template
      >

      <template #actions="{ data }">
        <div class="d-flex">
          <b-button
            size="sm"
            variant="flat-warning"
            :to="{
              name: 'edit-exercise',
              params: { id: data.item.id },
            }"
          >
            <feather-icon icon="EditIcon" />
            <span class="ml-50">ویرایش</span>
          </b-button>

          <b-button
            size="sm"
            variant="flat-danger"
            @click="removeExercise(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
      <template #row-details="{ data }">
        <div class="d-flex flex-wrap">
          <b-button
            v-for="(session, index) in data.item.sessions.sessions"
            :key="index"
            class="d-flex flex-column mr-2 p-50"
            variant="gradient-secondary"
            :to="{
              name: 'show-exercise',
              params: { id: data.item.id },
              query: {
                course_id: session.pivot.course_id,
                session_id: session.pivot.session_id,
              },
            }"
          >
            <small class="mb-50">{{
              "  دوره : " +
              (data.item.courses &&
              data.item.courses.courses &&
              data.item.courses.courses.length
                ? data.item.courses.courses.find(
                    (course) => course.id == session.pivot.course_id
                  ).name
                : "")
            }}</small>
            <small>{{ "  جلسه : " + session.name }}</small>
          </b-button>
        </div>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BAvatar,
  BCard,
  BDropdownItem,
  BDropdown,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BCard,
    BLink,
    BAvatar,
    BDropdownItem,
    BDropdown,
    BFormCheckbox,
    BForm,
    BFormInput,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      choosenPage: 1,

      selectAll: false,
      removeExercisesData: [],
      exercises: [],
      loading: false,
      url: "",
      currentPage: 1,
      pagination: {},
      visible: false,
      search: "",
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "detail", label: "جزییات" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeExercisesData = this.exercises.map(
              (semester) => semester.id
            ))
          : (this.removeExercisesData = []);
      },
      immediate: true,
    },
    removeExercisesData: {
      handler(val) {
        val.length == this.exercises.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.removeExercisesData = [];
        this.getExercises();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "exercises",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "exercises",
        });
      }
    },
  },
  async created() {
    if (this.$route.query.key) {
      this.$router.push({
        name: "exercises",
      });
    }
    this.url = `/panel/exercises?includes=sessions,courses`;
    await this.getExercises();
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "exercises",
          query: {
            key: this.search,
          },
        });
      }
    },
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },
    removeExercise(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این مورد حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/exercises/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeExercisesData = [];
                await this.getExercises();
              } else {
                await this.$router.push({
                  name: "exercises",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مورد با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeExercises() {
      if (this.removeExercisesData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید موارد انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeExercisesData.map(async (exercise, index) => {
                    await this.$http.delete(`/panel/exercises/${exercise}`);
                    if (index + 1 == this.removeExercisesData.length) {
                      resolve();
                    }
                  });
                });
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeExercisesData = [];
                  await this.getExercises();
                } else {
                  await this.$router.push({
                    name: "exercises",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مورد با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "موردی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getExercises() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.exercises = data.data.exercises;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
